import { TypeCredit } from './type-credit';

export class Produit {
    id: number|undefined;
    active: boolean;
    code: string;
    label: string;
    typeCredit:TypeCredit;
  }